import { actionCreator } from 'utils';
import * as FormVersionTypes from '../types/formVersionTypes';

// L O A D   F O R M   V E R S I O N S
export function loadFormVersions() {
    return {
        type: FormVersionTypes.LOAD_FORM_VERSIONS,
    };
}

export function loadFormVersionsRes(data) {
    return {
        type: actionCreator(FormVersionTypes.LOAD_FORM_VERSIONS, 'res'),
        data,
    };
}

export function loadFormVersionsErr() {
    return {
        type: actionCreator(FormVersionTypes.LOAD_FORM_VERSIONS, 'err'),
    };
}
// L O A D   F O R M   V E R S I O N S

// S E T   F O R M   V E R S I O N S   F I L T E R   &   P A G I N A T I O N   &   R E S E T
export function setFormVersionsFilters(key, value) {
    return {
        type: FormVersionTypes.SET_FORM_VERSIONS_FILTER,
        key,
        value,
    };
}

export function setFormVersionsPagination(key, pagination) {
    return {
        type: FormVersionTypes.SET_FORM_VERSIONS_PAGINATION,
        key,
        pagination,
    };
}

export function setFormVersionsSort(sort) {
    return {
        type: FormVersionTypes.SET_FORM_VERSIONS_SORT,
        sort,
    };
}

export function resetFormVersionsFilters() {
    return {
        type: FormVersionTypes.RESET_FORM_VERSIONS_FILTERS,
    };
}
// S E T   F O R M   V E R S I O N S   F I L T E R   &   P A G I N A T I O N   &   R E S E T


// S E L E C T   F O R M   V E R S I O N   F O R   R O L L   O U T
export function checkedFormVersionRecords(form) {
    return {
        type: FormVersionTypes.SELECT_FORM_VERSION_FOR_ROLL_OUT,
        form,
    };
}
// S E L E C T   F O R M   V E R S I O N   F O R   R O L L   O U T

// C R E A T E   R O L L   O U T
export function createRollOut(data) {
    return {
        type: FormVersionTypes.CREATE_ROLL_OUT,
        data,
    };
}

export function createRollOutRes(loading, success) {
    return {
        type: actionCreator(FormVersionTypes.CREATE_ROLL_OUT, 'res'),
        loading,
        success,
    };
}

export function createRollOutErr(error) {
    return {
        type: actionCreator(FormVersionTypes.CREATE_ROLL_OUT, 'err'),
        error,
    };
}
// C R E A T E   R O L L   O U T

// T O G G L E   F O R M   V E R S I O N   S T A T U S
export function toggleFormVersionStatus(data, load) {
    return {
        type: FormVersionTypes.TOGGLE_FORM_VERSION_STATUS,
        data,
        load,
    };
}
// T O G G L E   F O R M   V E R S I O N   S T A T U S

// C R E A T E   J O B   R E S U L T S
export function createJobResults(data) {
    return {
        type: FormVersionTypes.CREATE_JOB_RESULTS,
        data,
    };
}

export function createJobResultsRes() {
    return {
        type: actionCreator(FormVersionTypes.CREATE_JOB_RESULTS, 'res'),
    };
}

export function createJobResultsErr() {
    return {
        type: actionCreator(FormVersionTypes.CREATE_JOB_RESULTS, 'err'),
    };
}
// C R E A T E   J O B   R E S U L T S

// R E P O R T   J O B   E R R O R
export function reportJobError(data) {
    return {
        type: FormVersionTypes.REPORT_JOB_ERROR,
        data,
    };
}

export function reportJobErrorRes({ closePopup = true } = {}) {
    return {
        type: actionCreator(FormVersionTypes.REPORT_JOB_ERROR, 'res'),
        closePopup,
    };
}

export function reportJobErrorErr() {
    return {
        type: actionCreator(FormVersionTypes.REPORT_JOB_ERROR, 'err'),
    };
}
// R E P O R T   J O B   E R R O R

// R E P O R T   E R R O R   V I S I B I L I T Y
export function reportErrorPopupVisibility(data) {
    return {
        type: FormVersionTypes.REPORT_ERROR_POPUP_VISIBILITY,
        data,
    };
}
// R E P O R T   E R R O R   V I S I B I L I T Y

// D E L E T E   F O R M   V E R S I O N
export function deleteFormVersion(id) {
    return {
        type: FormVersionTypes.DELETE_FORM_VERSION,
        id,
    };
}

export function deleteFormVersionRes(id) {
    return {
        type: actionCreator(FormVersionTypes.DELETE_FORM_VERSION, 'res'),
        id,
    };
}

export function deleteFormVersionErr() {
    return {
        type: actionCreator(FormVersionTypes.DELETE_FORM_VERSION, 'err'),
    };
}
// D E L E T E   F O R M   V E R S I O N
